import { Injectable, InjectionToken, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SKIP_ERROR_NOTIFICATION } from '@core/http/http-error.interceptor';
import { AUTH_TOKEN_TYPE } from '@core/auth/auth-token.context';
import type { ConversionPayload } from '@typings/app/attribution.types';

/**
 * `POST https://shiftat.sa/api/sheets`. Held in a token rather than read from `environment`
 * so it can be varied in tests, matching how `initAnalytics` takes its container id.
 * An empty value disables dispatch, the same way an empty `googleTagManagerId` does.
 */
export const CONVERSIONS_API_URL = new InjectionToken<string>('CONVERSIONS_API_URL');

@Injectable({ providedIn: 'root' })
export class ConversionsApiService {
  private readonly http = inject(HttpClient);
  private readonly url = inject(CONVERSIONS_API_URL);

  /**
   * Fire-and-forget: the caller has just published a job post, and nothing about
   * reporting the conversion may reach them.
   */
  report(payload: ConversionPayload): void {
    if (!this.url) return;

    // 'none' is required, not merely tidy: AUTH_TOKEN_TYPE defaults to 'company', so
    // leaving it unset would attach the company JWT — and this endpoint is a different
    // origin, so that would hand shiftat.sa a live token on every conversion.
    const context = new HttpContext().set(AUTH_TOKEN_TYPE, 'none').set(SKIP_ERROR_NOTIFICATION, true);

    this.http.post(this.url, payload, { context }).subscribe({
      error: () => undefined, // reporting a conversion must never disrupt posting a job
    });
  }
}
